import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const AudioSettings02 = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24, fill = 'none' }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M6.12605 9.91314L17.7185 9.91307C19.7764 9.91307 21.4446 8.23122 21.4446 6.15655C21.4446 4.08188 19.7764 2.40002 17.7185 2.40002L6.12605 2.4001M6.12605 9.91314C4.06815 9.91314 2.3999 8.23129 2.3999 6.15662C2.3999 4.08195 4.06815 2.4001 6.12605 2.4001M6.12605 9.91314C8.18394 9.91314 9.85219 8.23129 9.85219 6.15662C9.85219 4.08195 8.18394 2.4001 6.12605 2.4001M17.8738 14.087H6.12605C4.06816 14.087 2.3999 15.7688 2.3999 17.8435C2.3999 19.9182 4.06815 21.6 6.12605 21.6H17.8738M17.8738 14.087C19.9317 14.087 21.5999 15.7688 21.5999 17.8435C21.5999 19.9182 19.9316 21.6 17.8738 21.6M17.8738 14.087C15.8159 14.087 14.1476 15.7688 14.1476 17.8435C14.1476 19.9182 15.8159 21.6 17.8738 21.6"
          stroke={color}
          strokeWidth="1.5"
        />
      </svg>
    )
  },
)

export default AudioSettings02
